import { render, staticRenderFns } from "./Bienvenida.vue?vue&type=template&id=4369d10a&"
import script from "./Bienvenida.vue?vue&type=script&lang=js&"
export * from "./Bienvenida.vue?vue&type=script&lang=js&"
import style0 from "./Bienvenida.vue?vue&type=style&index=0&id=4369d10a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports